// extracted by mini-css-extract-plugin
export default {"intop":"Details_intop__vhIbM","wrapper":"Details_wrapper__mk5Jb","ques":"Details_ques__WtYbR","icon":"Details_icon__GRU2n","ans":"Details_ans__czSUs"};